import React from 'react';

import { ProductGlyph, ProductLogo, ProductRow } from './styledComponents';

import { getMosProductVisual } from '../../utils/productVisuals';

const MosProductItem = ({ product, onClick }) => {
  const { iconUrl, brandColor } = getMosProductVisual(product.code);

  return (
    <ProductRow onClick={onClick}>
      <ProductLogo brandColor={brandColor}>
        <ProductGlyph iconUrl={iconUrl} />
      </ProductLogo>
      {product.name}
    </ProductRow>
  );
};

export default MosProductItem;
